import request from '@/plugins/axios-java-formdata'
const baseURL = '/api/merchant/newgateway'

/**
 * @api 获取发票功能权限
 */
export function getInvoicePermissionServer () {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.invoice.permission'
  })
}

/**
 * @api 获取统计信息
 */
export function getInvoiceStatisticDataServer (data) {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.invoice.info',
    data
  })
}
/**
 * @api 获取发票列表页面
 */
export function getInvoiceListServer (data) {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.invoice.record',
    data
  })
}
/**
 * @api 获取发票详情
 */
export function getInvoiceDetailServer (data) {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.invoice.detail',
    data
  })
}
/**
 * @api 获取开票页面详情
 */
export function getInvoiceQrCodeInfoServer (data) {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.invoice.open.detail',
    data
  })
}
/**
 * @api 获取发票配置信息
 */
export function getInvoiceConfigListServer (data) {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.invoice.issueinfo',
    data
  })
}
/**
 * @api 开票
 */
export function openInvoiceServer (data) {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.invoice.open',
    data
  })
}
/**
 * @api 红冲
 */
export function redInkInvoiceServer (data) {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.app.invoice.refund',
    data
  })
}
/**
 * @api 开票获取门店列表
 */
export function invoiceStoreListServer (data) {
  return request({
    baseURL,
    method: 'post',
    javaMethods: 'com.fshows.lifecircle.invoice.store.list',
    data
  })
}
